import React from 'react';
import PeopleIcon from 'Icons/People';
import bemit from 'Functions/bemit';
import { b_seminar_ranges } from 'Shared/options';
export default function SpaceAvailability({
  ...props
}) {
  let middle = props.data.length / 2;
  if (parseInt(middle) < middle) {
    middle = parseInt(middle + 1);
  }
  const half_day_layout = ['c_open_coworking_space', 'b_seminar'].includes(props.type);
  const items = props.data.map(function (infos, i) {
    const modifiers = [props.type].concat(props.bemit || []);
    if (infos.too_little_seats) modifiers.push('too-little-seats');
    if (['c_open_coworking_space', 'b_seminar'].includes(props.type) && infos.available === false) {
      modifiers.push('reserved');
    }
    if (infos.delta_expired) {
      modifiers.push('expired');
    }
    let start = infos.start;
    if (half_day_layout) {
      const config = b_seminar_ranges.find(config => config.value === start);
      start = config ? config.label : '';
      if (infos.available && infos.hours_range) {
        start += ' (' + infos.hours_range + ')';
      }
    } else {
      start = infos.start ? infos.start + 'h' : '';
    }
    let availability_status;
    if (props.type === 'b_seminar') {
      let label = infos.available ? 'Disponible' : infos.full || infos.too_little_seats ? 'Réservé' : infos.delta_expired ? 'Expiré' : 'Fermé';
      availability_status = /*#__PURE__*/React.createElement("div", {
        className: "c-availability__status"
      }, props.type === 'c_open_coworking_space' && (infos.available || infos.too_little_seats), label);
    } else if (props.type === 'c_open_coworking_space') {
      let label = infos.available ? infos.remaining_seats : infos.full ? 'Réservé' : infos.delta_expired ? 'Expiré' : 'Fermé';
      availability_status = /*#__PURE__*/React.createElement("div", {
        className: "c-availability__status"
      }, label, infos.available ? /*#__PURE__*/React.createElement(PeopleIcon, {
        className: "c-availability__people-icon"
      }) : undefined);
    } else {
      availability_status = /*#__PURE__*/React.createElement("div", {
        className: "c-availability__seats"
      }, infos.remaining_seats, /*#__PURE__*/React.createElement(PeopleIcon, {
        className: "c-availability__people-icon"
      }));
    }
    const output = /*#__PURE__*/React.createElement("div", {
      className: bemit('c-availability', modifiers),
      key: infos.start
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-availability__start"
    }, start), infos.end ? /*#__PURE__*/React.createElement("div", {
      className: "c-availability__end"
    }, infos.end, "h") : undefined, availability_status);
    return output;
  });
  let left, right;
  if (half_day_layout) {
    left = items;
  } else {
    left = /*#__PURE__*/React.createElement("div", {
      className: "o-space-availability__column"
    }, items.slice(0, middle));
    right = /*#__PURE__*/React.createElement("div", {
      className: "o-space-availability__column"
    }, items.slice(middle));
  }
  const modifiers = [props.type].concat(props.bemit || []);
  const output = /*#__PURE__*/React.createElement("div", {
    className: bemit('o-space-availability', modifiers)
  }, /*#__PURE__*/React.createElement("div", {
    className: "o-space-availability__content"
  }, left, right));
  return output;
}
